import { ACCOUNT_ICONS_VARIANTS } from "./AccountIcon";

export const getAccountIconVariant = (index: number) =>
  ACCOUNT_ICONS_VARIANTS[index % ACCOUNT_ICONS_VARIANTS.length];
